import styled from 'styled-components';

const JourneySelectorContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
`;

export { JourneySelectorContainer };
